import { EntryIntent } from './types';

const STORAGE_KEY = 'comoLinkEntryIntent';
const MAX_AGE_MS = 5 * 60 * 1000;
const LOCAL_PATH = /^\/[A-Za-z0-9_-]+(\/[A-Za-z0-9_-]+)*$/;

export const isSafeLocalPath = (path: unknown): path is string => typeof path === 'string' && LOCAL_PATH.test(path);

export const clearEntryIntent = (): void => {
  try {
    sessionStorage.removeItem(STORAGE_KEY);
  } catch (e) {
    // Storage unavailable: nothing to clear.
  }
};

export const recordEntryIntent = (path: string, now: number): boolean => {
  if (!isSafeLocalPath(path)) return false;
  const intent: EntryIntent = { kind: 'dashboard-page', path, createdAt: now };
  try {
    sessionStorage.setItem(STORAGE_KEY, JSON.stringify(intent));
    return true;
  } catch (e) {
    return false;
  }
};

const readIntent = (): EntryIntent | null => {
  try {
    const parsed = JSON.parse(sessionStorage.getItem(STORAGE_KEY) || 'null');
    if (
      parsed &&
      parsed.kind === 'dashboard-page' &&
      isSafeLocalPath(parsed.path) &&
      Number.isFinite(parsed.createdAt)
    ) {
      return { kind: parsed.kind, path: parsed.path, createdAt: parsed.createdAt };
    }
  } catch (e) {
    // Unreadable or unparsable content is treated as no intent.
  }
  return null;
};

// One-shot: the intent is removed whether or not it matches, so it never outlives the first route start.
export const consumeEntryIntent = (programPath: string, now: number): EntryIntent | null => {
  const intent = readIntent();
  clearEntryIntent();
  if (!intent) return null;

  const age = now - intent.createdAt;
  const fresh = age >= 0 && age <= MAX_AGE_MS;
  const matches = intent.path === programPath || intent.path.startsWith(`${programPath}/`);
  return fresh && matches ? intent : null;
};

interface OpenedProgram {
  path: string;
  comoBacked?: boolean;
  regularLink?: boolean;
}

export const isInsideProgram = (programPath: string, currentPath: string): boolean =>
  currentPath === programPath || currentPath.startsWith(`${programPath}/`);

// Opening a migrated program from a menu hands off straight to COMO; moving within it must not.
export const recordProgramOpenIntent = (page: OpenedProgram, currentPath: string, now: number): void => {
  if (page.comoBacked && !page.regularLink && !isInsideProgram(page.path, currentPath)) {
    recordEntryIntent(page.path, now);
  }
};
